import React from "react";
import {useSelector, useDispatch} from "react-redux";
import Alert from "@material-ui/lab/Alert";
import Snackbar from "@material-ui/core/Snackbar";
import {HideSnackbar} from "../../actions";

const GlobalSnackbar = () => {
    const snackbarState = useSelector((state: any) => state.snackbar);
    const dispatch = useDispatch();
    return (
        <>
            <Snackbar
                anchorOrigin={{
                    vertical: "top",
                    horizontal: "center",
                }}
                open={snackbarState.content !== ""}
                autoHideDuration={2000}
                onClose={() => dispatch(HideSnackbar())}
            >
                {snackbarState.isError ? (
                    <Alert severity="error">{snackbarState.content}</Alert>
                ) : (
                    <Alert severity="success">{snackbarState.content}</Alert>
                )}
            </Snackbar>
        </>
    );
};

export default GlobalSnackbar;
